"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var components_1 = require("@athena-portal/components");
var InsuredVehicleTree_1 = require("./InsuredVehicleTree");
var InsuredPersonTree_1 = require("./InsuredPersonTree");
var Person_1 = require("../../model/Person");
var InsuredRealEstateTree_1 = require("./InsuredRealEstateTree");
var services_1 = require("@falcon/services");
var InsuredValuableItemsTree_1 = require("./InsuredValuableItemsTree");
var Page_1 = require("../Page");
var InsuredPropertyTree_1 = require("./InsuredPropertyTree");
var Tree_1 = require("../../components/Tree");
var InvolvedObjectsTree = /** @class */ (function (_super) {
    __extends(InvolvedObjectsTree, _super);
    function InvolvedObjectsTree(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates;
        _this.renderInsuredRealEstates = function () {
            return _this.props.policyVersion.insuredRealEstates.map(function (realEstate, index) { var _a; return (0, jsx_runtime_1.jsx)(InsuredRealEstateTree_1.default, { realEstate: realEstate, interaction: _this.props.interaction }, index.toString() + ((_a = realEstate.realEstateTypeSubType) === null || _a === void 0 ? void 0 : _a.code)); });
        };
        _this.renderValuableItems = function () {
            return _this.props.policyVersion.insuredValuableItems.map(function (valuableItem) {
                return (0, jsx_runtime_1.jsx)(InsuredValuableItemsTree_1.default, { valuableItem: valuableItem }, valuableItem.id);
            });
        };
        _this.renderInsuredVehicles = function () {
            var _a;
            var insuredVehicles = [];
            var _loop_1 = function (vehicle) {
                var interactionVehicle = null;
                var overnightPostcode = "";
                var basicDetails = [
                    vehicle.registrationNumber,
                    vehicle.make,
                    vehicle.model,
                    vehicle.year.toString()
                ];
                if (_this.state && _this.props.interaction) {
                    interactionVehicle = _this.props.interaction.vehicles.filter(function (car) {
                        return car.registrationNumber === vehicle.registrationNumber;
                    })[0];
                    overnightPostcode = interactionVehicle.overnightLocationIsHome && ((_a = _this.props.interaction.policyHolder) === null || _a === void 0 ? void 0 : _a.address) ?
                        _this.props.interaction.policyHolder.address.postcode :
                        interactionVehicle.overnightLocationPostcode;
                }
                var detailString = basicDetails.join(", ");
                insuredVehicles.push((0, jsx_runtime_1.jsx)(InsuredVehicleTree_1.default, { vehicle: vehicle, interactionVehicle: interactionVehicle, drivers: _this.getVehicleDrivers(), treeContentString: detailString, overnightPostcode: overnightPostcode }, vehicle.id));
            };
            for (var _i = 0, _b = _this.props.policyVersion.insuredVehicles; _i < _b.length; _i++) {
                var vehicle = _b[_i];
                _loop_1(vehicle);
            }
            return insuredVehicles;
        };
        _this.renderInsuredPersons = function () {
            var _a;
            var insuredPersons = [];
            for (var _i = 0, _b = _this.props.policyVersion.insuredPersons; _i < _b.length; _i++) {
                var person = _b[_i];
                var interactionPerson = null;
                var personTitle = "";
                var addressDetails = [
                    person.address.addressLine1,
                    person.address.addressLine2,
                    person.address.addressLine3,
                    person.address.addressLine4,
                    person.address.postalCode
                ];
                if (_this.props.interaction) {
                    interactionPerson = _this.getInteractionPerson(person);
                    if (interactionPerson === null || interactionPerson === void 0 ? void 0 : interactionPerson.title) {
                        personTitle = interactionPerson.title.charAt(0) + interactionPerson.title.substring(1).toLowerCase() + " ";
                    }
                }
                var address = addressDetails.filter(Boolean).join(", ");
                var dateOfBirthString = ", " + _this.supportPortalTemplates.convertDate(person.dateOfBirth, "DD/MM/YYYY");
                if (!_this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR", "Read_Only"])) {
                    dateOfBirthString = "";
                }
                var detailsString = personTitle + person.firstName + " " + person.lastName + dateOfBirthString;
                if (((_a = _this.props.interaction.jointPolicyHolder) === null || _a === void 0 ? void 0 : _a.internalId) === person.id) {
                    detailsString = "(JPH) ".concat(detailsString);
                }
                insuredPersons.push((0, jsx_runtime_1.jsx)(InsuredPersonTree_1.default, { person: person, interactionPerson: interactionPerson, treeContentString: detailsString, address: address, interaction: _this.props.interaction }, person.id));
            }
            return insuredPersons.reverse();
        };
        _this.getVehicleDrivers = function () {
            var allDrivers = [];
            var vehicleDrivers = [];
            if (_this.state && _this.props.interaction) {
                allDrivers.push(_this.props.interaction.policyHolder);
                allDrivers.push.apply(allDrivers, _this.props.interaction.additionalDrivers);
                for (var _i = 0, allDrivers_1 = allDrivers; _i < allDrivers_1.length; _i++) {
                    var driver = allDrivers_1[_i];
                    if (driver.personId === _this.props.interaction.vehicles[0].registeredKeeperId) {
                        var registeredKeeper = new Person_1.default();
                        registeredKeeper.objectRole = "registeredKeeper";
                        registeredKeeper.firstName = driver.firstName;
                        registeredKeeper.lastName = driver.lastName;
                        registeredKeeper.id = driver.personId;
                        vehicleDrivers.push(registeredKeeper);
                    }
                    if (driver.personId === _this.props.interaction.vehicles[0].mainDriverId) {
                        var mainDriver = new Person_1.default();
                        mainDriver.objectRole = "mainDriver";
                        mainDriver.firstName = driver.firstName;
                        mainDriver.lastName = driver.lastName;
                        mainDriver.id = driver.personId;
                        vehicleDrivers.push(mainDriver);
                    }
                    if (driver.personId !== _this.props.interaction.vehicles[0].registeredKeeperId && driver.personId !== _this.props.interaction.vehicles[0].mainDriverId) {
                        var additionalDriver = new Person_1.default();
                        additionalDriver.objectRole = "additionalDriver";
                        additionalDriver.firstName = driver.firstName;
                        additionalDriver.lastName = driver.lastName;
                        additionalDriver.id = driver.personId;
                        vehicleDrivers.push(additionalDriver);
                    }
                }
            }
            return vehicleDrivers;
        };
        _this.state = {};
        return _this;
    }
    InvolvedObjectsTree.prototype.render = function () {
        if (this.props.interaction) {
            return ((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: "Involved objects", children: [this.renderInsuredPersons(), (services_1.productHelper.isMotor(this.props.interaction) || services_1.productHelper.isWolfMotor(this.props.interaction)) && this.renderInsuredVehicles(), services_1.productHelper.isRenters(this.props.interaction) && this.renderInsuredRealEstates(), services_1.productHelper.isRenters(this.props.interaction) && this.renderValuableItems(), this.props.interaction && services_1.productHelper.isHome(this.props.interaction) &&
                        (0, jsx_runtime_1.jsx)(InsuredPropertyTree_1.default, { interaction: this.props.interaction })] }));
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    InvolvedObjectsTree.prototype.getInteractionPerson = function (person) {
        var _a, _b;
        if (person.objectRole === "POLICY_HOLDER"
            && ((_a = this.props.interaction.policyHolder) === null || _a === void 0 ? void 0 : _a.internalId) === person.id) {
            return this.props.interaction.policyHolder;
        }
        else if (((_b = this.props.interaction.jointPolicyHolder) === null || _b === void 0 ? void 0 : _b.internalId) === person.id) {
            return this.props.interaction.jointPolicyHolder;
        }
        else if (this.props.interaction.additionalDrivers) {
            return this.props.interaction.additionalDrivers.find(function (driver) { return driver.internalId === person.id; });
        }
        return null;
    };
    InvolvedObjectsTree.contextType = Page_1.PageContext;
    InvolvedObjectsTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], InvolvedObjectsTree);
    return InvolvedObjectsTree;
}(React.Component));
exports.default = InvolvedObjectsTree;
//# sourceMappingURL=InvolvedObjectsTree.js.map